module.exports = "https://static.energy5.com/_next/static/images/effortless1-e8b11e53e6b4a69a29e24880e9d3c951.png";